/* global Helpers */
import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { H6, P } from '@PipelineDeals/shared-react-components'

import { Section } from 'components/BusinessCard/components/StyledComponents'
import { useBusinessCard } from 'components/BusinessCard/context'

import SimpleSection from 'components/BusinessCard/components/SimpleSection'

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${({ $hexColor, theme }) => $hexColor ? `#${$hexColor}` : theme.colors.gray[200]};
  color: ${({ $hexColor }) => $hexColor ? '#fff' : '#333'};
`

const ProjectLink = styled.a`
  color: ${({ theme }) => theme.colors.blue[500]};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

const ProjectMilestone = () => {
  const { t } = useTranslation()
  const {
    cardMeta: {
      showOnlyFields
    },
    resource: milestone
  } = useBusinessCard()

  const statusDisplay = () => {
    if (!milestone.status) return null

    return (
      <StatusBadge $hexColor={milestone.status.hex_color}>
        {milestone.status.name}
      </StatusBadge>
    )
  }

  const projectLink = () => {
    if (!milestone.project) return null

    return (
      <ProjectLink href={`/projects/${milestone.project.id}`}>
        {milestone.project.name}
      </ProjectLink>
    )
  }

  return (
    <>
      <SimpleSection
        field="status"
        value={statusDisplay()}
        label={t('businessCard.labels.status')}
      />

      {showOnlyFields.includes('project') && milestone.project && (
        <Section>
          <H6>{t('businessCard.labels.project')}</H6>
          <P>{projectLink()}</P>
        </Section>
      )}

      <SimpleSection
        field="start_date"
        value={milestone.start_date ? Helpers.formatDate(milestone.start_date) : null}
        label={t('businessCard.labels.startDate')}
      />

      <SimpleSection
        field="end_date"
        value={milestone.end_date ? Helpers.formatDate(milestone.end_date) : null}
        label={t('businessCard.labels.endDate')}
      />
    </>
  )
}

export default ProjectMilestone
